import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 450px;
  max-width: 100%; /* Ensures it never exceeds viewport width */
  background-color: #011741;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transform: translateX(${(props) => (props.show ? '0' : '100%')});
  transition: transform 0.3s ease-in-out;
  display: flex;
  flex-direction: column;

  @media (max-width: 480px) {
    width: 100%; /* Take full width on small screens */
  }
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 999;
  display: ${(props) => (props.show ? 'block' : 'none')};
`;

export const Header = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #011741;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 2;
`;

export const Body = styled.div`
  padding: 24px;
  flex: 1;
  overflow-y: auto;
  position: relative;
  z-index: 1;
`;

export const Footer = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #011741;
  display: flex;
  justify-content: flex-end;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 2;
`;
